/**
 * Focus */
// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FocusIfDirective } from "./focus-if.directive";


@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        FocusIfDirective
    ],
    exports: [
        FocusIfDirective
    ]
})
export class FocusIfModule { }